import { Link } from 'react-router-dom'
import { greekToLatin } from '@/lib/api'
import { useFavorites, type FavoriteRoute } from '@/lib/useFavorites'

type Language = 'el' | 'en'

interface FavoritesBarProps {
  lang: Language
}

// Group favorites by lineId
function groupByLine(favorites: FavoriteRoute[]): Map<string, FavoriteRoute[]> {
  const grouped = new Map<string, FavoriteRoute[]>()
  
  for (const fav of favorites) {
    const existing = grouped.get(fav.lineId) || []
    grouped.set(fav.lineId, [...existing, fav])
  }
  
  return grouped
}

export function FavoritesBar({ lang }: FavoritesBarProps) {
  const { favorites } = useFavorites()

  if (favorites.length === 0) {
    return null
  }

  const groupedFavorites = groupByLine(favorites)
  const toLabel = lang === 'el' ? 'προς' : 'to'

  return (
    <div className="favorites-bar">
      {Array.from(groupedFavorites.entries()).map(([lineId, lineFavorites]) => (
        <div key={lineId} className="favorites-line-group">
          <div className="favorites-line-badge">
            <Link to={`/${greekToLatin(lineId).toLowerCase()}`}>
              {lineId}
            </Link>
          </div>
          <div className="favorites-line-stops">
            {lineFavorites.map(fav => (
              <Link
                key={fav.id}
                to={`/${greekToLatin(fav.lineId).toLowerCase()}/${fav.routeCode}/${fav.stopCode}`}
                className="favorites-stop-item"
              >
                <span className="favorites-stop-direction">{toLabel} {fav.routeDescription}</span>
                <span className="favorites-stop-name">{fav.stopName}</span>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
